import { Component, OnInit } from '@angular/core';
import { Note, NotesService } from '../services/notes.service';
import { List, Map } from 'immutable';
import { Auth, Unsubscribe } from '@angular/fire/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-app',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  private notes: Map<string, Note>;
  public sortedNotes: List<Note>;
  private unsub: List<Unsubscribe>;
  constructor(
    private _notesService: NotesService,
    private auth: Auth,
    private router: Router
  ) {
    this.unsub = List();
  }

  /**
   * On init
   * - subscribes to the notes observable
   */
  public ngOnInit() {
    if (!this.auth.currentUser) {
      this.router.navigate(['/login']);
    }
    const notesSub = this._notesService
      .getNotesUpdatedObservable()
      .subscribe((value) => {
        this.notes = value;
        this.sortedNotes = List<Note>()
          .withMutations((list) => {
            for (let note of this.notes.values()) {
              list.push(note);
            }
          })
          .sortBy((note) => note.timestamp)
          .reverse();
      });
    this.unsub = this.unsub.push(notesSub.unsubscribe);
  }

  /**
   * on destroy, unsubuscribes from all
   */
  public ngOnDestroy() {
    for (const unsub of this.unsub) {
      unsub();
    }
    this.unsub = List();
  }

  /**
   * On Submit, creates a note with notes service;
   * @param noteObj
   * @param event
   */
  public onSubmit(noteObj, event) {
    event.preventDefault();
    const note = noteObj.value;
    noteObj.value = '';
    if (note && note.length > 0) {
      this._notesService.createNote(note).then();
    }
  }
}
